<div class="my-5">
  <!-- page-header -->
  <sm-page-header [breadcrumb]="breadcrumb" [title]="title" description=""> </sm-page-header>

  <!-- content -->
  <div class="content">
    <div class="flex flex-row gap-5 mb-4">
      <div class="w-3/4">
        <sm-form-builder [formObject]="formObject"></sm-form-builder>
      </div>
      <div class="content w-1/4 h-fit">
        <sm-block-builder [blocks]="controlBlocks"></sm-block-builder>
      </div>
    </div>

    <div *ngIf="(dacRepository.getNestedObservable('dto.isStatic') | async) === false">
      <!-- Only show fields table and print button in edit mode -->
      <ng-container *ngIf="isEditMode">
        <div class="flex justify-end mb-2">
          <button pButton type="button" icon="pi pi-plus" [label]="'dynamicDocument.form.addField' | translate" (click)="openFieldEditor()"></button>
        </div>

        <sm-section-variables-list
          #sectionVariablesList
          [dynaDocsId]="dacRepository.getNestedObservable('dto.id') | async"
          [dynaDocsVer]="(dacRepository.getNestedObservable('dto.version') | async) || 1"
          (editLocalField)="onEditLocalField($event)"
          (deleteLocalField)="onDeleteLocalField($event)"
          (createLocalField)="onQuickCreateLocalField($event)"
        ></sm-section-variables-list>

        <sm-template-placeholders-review
          #placeholdersReview
          [dynaDocsId]="dacRepository.getNestedObservable('dto.id') | async"
          [dynaDocsVer]="(dacRepository.getNestedObservable('dto.version') | async) || 1"
          [nextOrderStart]="(dacRepository.getFields()).length + 1"
          (completed)="onPlaceholdersCreated()"
        ></sm-template-placeholders-review>
      </ng-container>

      <sm-drawer #fieldEditorDrawer [drawer]="fieldEditorDrawerObject" [(visible)]="showFieldEditor"></sm-drawer>
    </div>
  </div>
</div>